import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function DatabaseUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-4088">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4089">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-4090">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-4091">
            The local business database for{' '}
            <span className="text-blue-600" data-id="element-4092">every team</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-4093">
            From sales to marketing, see how teams use our local business owner
            finder to grow their revenue.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4094">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4095">
            <div data-id="element-4096">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4097">
                B2B sales outreach
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4098">
                Sales teams use our built-in email sequencing to reach local
                small businesses directly, bypassing gatekeepers with verified
                business owner emails.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4099">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4100" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4101">
                Having the database and sequencing in one tool doubled our SDRs'
                daily output.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4102">
                — Mark R., VP of Sales
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4103">
            <div data-id="element-4104">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4105">
                Local marketing
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4106">
                Agencies build hyper-targeted local business listings to run
                personalized campaigns for their clients across specific regions
                and industries.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4107">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4108" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4109">
                The local business database coverage is unmatched. We find
                niches ZoomInfo completely misses.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4110">
                — Elena S., Agency Owner
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4111">
            <div data-id="element-4112">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4113">
                Franchise expansion
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4114">
                Franchisors use the local business owner finder to identify
                successful independent operators and pitch them on conversion
                opportunities.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4115">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4116" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4117">
                We can view business owner emails before exporting, ensuring we
                only contact the actual decision makers.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4118">
                — David L., Head of Growth
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}